import { roleTypes } from '../types';

export function isAllSelected(
  selected: roleTypes.PageAccessDepartment[],
  allDepartments: roleTypes.PageAccessDepartment[]
): boolean {
  return allDepartments.every((department) => selected.includes(department));
}

export function isAnySelected(
  selected: roleTypes.PageAccessDepartment[],
  allDepartments: roleTypes.PageAccessDepartment[]
): boolean {
  return allDepartments.some((department) => selected.includes(department));
}
